import {
  NotificationItem,
  NotificationItemVariant,
} from 'modules/notification/subcomponents/NotificationItem';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { LoadingSpinner } from 'shared/components/LoadingSpinner/LoadingSpinner';
import { Notification } from 'types/Notification';

interface NotificationListProps {
  notifications: Notification[];
  placeholder?: string;
  loading?: boolean;
  className?: string;
  itemVariant?: NotificationItemVariant;
  onRedirect?: () => void;
}

export const NotificationList: FC<NotificationListProps> = ({
  notifications,
  placeholder,
  loading = false,
  className = '',
  itemVariant = 'full',
  onRedirect,
}) => {
  const { t } = useTranslation('notification');

  if (loading) {
    return (
      <div className="flex justify-center py-12">
        <LoadingSpinner />
      </div>
    );
  }

  if (!notifications.length) {
    return (
      <div className="flex justify-center py-[100px]">
        <p className="text-gray">{placeholder || t('listPlaceholder')}</p>
      </div>
    );
  }

  return (
    <div className={className}>
      <ul className="overflow-hidden rounded-lg">
        {notifications.map((notification) => (
          <NotificationItem
            key={notification.id}
            {...notification}
            variant={itemVariant}
            onRedirect={onRedirect}
          />
        ))}
      </ul>
    </div>
  );
};
